













































































































































































































import {myVue} from "@/components/class/myVue";
import {Component } from 'vue-property-decorator';
import * as utils from "@/components/util/utils";
@Component
export default class HelloWorld extends myVue {
    data() {
        return {
            tableData: [{
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1517 弄'
            }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1516 弄'
            }],
        }
    }
    myBtnList (data:any) {
        let list =[]
        for(let i=0;i<this.current.tableBtn.length;i++){
            let item = this.current.tableBtn[i];
            let bool = utils.isJurisdiction({
                process:item.process,
                jurisdictionList:item.jurisdictionJson,
                data:{row:data.row}
            })
            if(bool){
                list.push(item)
            }
        }
        return list
    }
    myBtnOne (data:any) {
        let list = this.myBtnList(data);
        if(list.length>0){
            return list[0]
        }else{
            return {}
        }
    }
    myShowSummary (param:any) {
        return this.current.summaryData(param)
    }
    row_style ({row, rowIndex}:any) {
        return this.current.row_style({row, rowIndex,that:this.current})
    }
    handleSizeChange (val:any) {         // 更新查询的行数
        this.current.rows = val
        this.reQuery("content")
    }
    handleCurrentChange (val:any) {            // 更新查询的页数
        this.current.currentPage = val
        this.reQuery("content")
    }
    sortChange (a:any, b:any, c:any) {
    }
    selectionChange (selection:any) {
        this.current.selectRow = selection
    }
    rowClick (row:any, b:any, c:any) {
        this.current.selectRowOnly = row
        this.current.rowClick({row:row})
    }
    cellClick (a:any, b:any, c:any) {
    }
    cellMouseEnter (a:any, b:any, c:any) {
    }
    public_click (data:any) {
        this.current.selectRowOnly = data.row
        data.item.click({row:data.row})
    }
    public_click2 (data:any) {
        this.current.selectRowOnly = data.row
        data.item.click()
    }
}

